import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TaxCalendar = ({ compact = false }) => {
  const upcomingDeadlines = [
    {
      id: 1,
      title: 'Federal Income Tax Payment',
      date: '2026-01-31',
      type: 'payment',
      amount: '$24,680',
      urgency: 'high',
      description: 'Q4 2025 estimated tax payment'
    },
    {
      id: 2,
      title: 'Payroll Tax Filing',
      date: '2026-02-10',
      type: 'filing',
      amount: '$8,320',
      urgency: 'medium',
      description: 'Form 941 for Q4 2025'
    },
    {
      id: 3,
      title: 'Sales Tax Return - NY',
      date: '2026-02-15',
      type: 'filing',
      amount: '$12,450',
      urgency: 'medium',
      description: 'Q1 2026 sales tax filing'
    },
    {
      id: 4,
      title: 'Property Tax Payment',
      date: '2026-03-01',
      type: 'payment',
      amount: '$5,200',
      urgency: 'low',
      description: 'Annual property tax'
    },
    {
      id: 5,
      title: '1099 Forms Distribution',
      date: '2026-03-15',
      type: 'filing',
      amount: null,
      urgency: 'medium',
      description: 'Send 1099s to contractors'
    }
  ];

  const getUrgencyColor = (urgency) => {
    const colors = {
      high: 'border-l-red-500 bg-red-50',
      medium: 'border-l-yellow-500 bg-yellow-50',
      low: 'border-l-blue-500 bg-blue-50'
    };
    return colors?.[urgency] || colors?.medium;
  };

  const getTypeIcon = (type) => {
    return type === 'payment' ? 'CreditCard' : 'FileText';
  };

  const displayDeadlines = compact ? upcomingDeadlines?.slice(0, 3) : upcomingDeadlines;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Icon name="Calendar" size={24} className="text-primary" />
          <h2 className="text-xl font-semibold text-gray-900">Tax Calendar</h2>
        </div>
        {!compact && (
          <Button variant="outline" size="sm" iconName="Plus">
            Add Deadline
          </Button>
        )}
      </div>
      <div className="space-y-3">
        {displayDeadlines?.map((deadline) => (
          <div
            key={deadline?.id}
            className={`border-l-4 rounded-lg p-4 ${getUrgencyColor(deadline?.urgency)}`}
          >
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-3 flex-1">
                <div className="mt-1">
                  <Icon name={getTypeIcon(deadline?.type)} size={20} className="text-gray-700" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900">{deadline?.title}</h3>
                  <p className="text-sm text-gray-600 mt-1">{deadline?.description}</p>
                  <div className="flex items-center gap-4 mt-2 text-sm text-gray-700">
                    <span className="flex items-center gap-1">
                      <Icon name="Calendar" size={14} />
                      {new Date(deadline.date)?.toLocaleDateString('en-US', { 
                        month: 'short', 
                        day: 'numeric', 
                        year: 'numeric' 
                      })}
                    </span>
                    {deadline?.amount && (
                      <span className="font-semibold">{deadline?.amount}</span>
                    )}
                  </div>
                </div>
              </div>
              {!compact && (
                <Button variant="ghost" size="sm" iconName="MoreVertical" />
              )}
            </div>
          </div>
        ))}
      </div>
      {compact && (
        <div className="mt-4 text-center">
          <Button variant="link" size="sm">
            View All Deadlines
          </Button>
        </div>
      )}
    </div>
  );
};

export default TaxCalendar;